import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Label } from "../ui/label";
import { DASHBOARD_BACKGROUNDS } from "../../lib/dashboardAppearance";

export default function DashboardAppearanceDialog({ open, onOpenChange, appearance, onChange }) {
  const mode = appearance?.mode || "auto";
  const overlay = appearance?.overlay || "medium";
  const backgroundId = appearance?.backgroundId;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] overflow-y-auto max-w-2xl" data-testid="dashboard-visual-appearance-dialog">
        <DialogHeader>
          <DialogTitle>Apariencia del panel</DialogTitle>
          <DialogDescription>
            Elija cómo se muestra la carátula. Esta preferencia se guarda solo en este dispositivo y no incluye datos clínicos.
          </DialogDescription>
        </DialogHeader>

        <fieldset className="space-y-2">
          <legend className="text-sm font-medium text-slate-900">Modo visual</legend>
          {[
            { id: "auto", label: "Automático", hint: "Fotografía según la hora local y el día." },
            { id: "fixed", label: "Fotografía fija", hint: "Conserve un fondo elegido." },
            { id: "none", label: "Sin fotografía", hint: "Fondo sereno de color, sin imagen." },
          ].map((option) => (
            <label
              key={option.id}
              className="flex items-start gap-3 rounded-lg border border-slate-200 p-3 cursor-pointer hover:bg-slate-50"
            >
              <input
                type="radio"
                name="visual-mode"
                value={option.id}
                checked={mode === option.id}
                onChange={() => onChange({ ...appearance, mode: option.id })}
                className="mt-1"
                data-testid={`appearance-mode-${option.id}`}
              />
              <span>
                <span className="block text-sm font-medium text-slate-900">{option.label}</span>
                <span className="block text-xs text-slate-600">{option.hint}</span>
              </span>
            </label>
          ))}
        </fieldset>

        {mode === "fixed" ? (
          <div className="space-y-2">
            <Label>Fondo preferido</Label>
            <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
              {DASHBOARD_BACKGROUNDS.map((bg) => (
                <button
                  key={bg.id}
                  type="button"
                  onClick={() => onChange({ ...appearance, backgroundId: bg.id, mode: "fixed" })}
                  className={`overflow-hidden rounded-lg border-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-600 ${
                    backgroundId === bg.id ? "border-sky-600" : "border-transparent"
                  }`}
                  data-testid={`appearance-bg-${bg.id}`}
                >
                  <img src={bg.src} alt={bg.label} className="h-16 w-full object-cover" />
                  <span className="sr-only">{bg.label}</span>
                </button>
              ))}
            </div>
          </div>
        ) : null}

        <fieldset className="space-y-2">
          <legend className="text-sm font-medium text-slate-900">Intensidad del sombreado</legend>
          <div className="flex flex-wrap gap-2">
            {[
              { id: "light", label: "Claro" },
              { id: "medium", label: "Medio" },
              { id: "dark", label: "Oscuro" },
            ].map((option) => (
              <label
                key={option.id}
                className={`flex min-h-11 items-center gap-2 rounded-lg border px-3 py-2 cursor-pointer ${
                  overlay === option.id ? "border-sky-600 bg-sky-50" : "border-slate-200"
                }`}
              >
                <input
                  type="radio"
                  name="overlay"
                  value={option.id}
                  checked={overlay === option.id}
                  onChange={() => onChange({ ...appearance, overlay: option.id })}
                  data-testid={`appearance-overlay-${option.id}`}
                />
                <span className="text-sm text-slate-800">{option.label}</span>
              </label>
            ))}
          </div>
        </fieldset>
      </DialogContent>
    </Dialog>
  );
}
